/* ============================================================================
   cl-pdp-sticky.js — de keuze in de sticky koopbalk

   Doet één ding: een klik in een uitklapper doorgeven aan het échte
   productformulier hierboven. Daarna doet het thema alles wat erop volgt — de
   prijs bijwerken, de beschikbaarheid, en de foto in de balk zelf, want die
   draagt `data-product-media-wrapper`.

   Er zit dus géén tweede variant-logica in dit bestand. Dat is met opzet: twee
   plekken die allebei bepalen welke variant gekozen is, is twee plekken die uit
   elkaar kunnen lopen — en dat merk je pas als iemand de verkeerde maat krijgt.

   Het openen en sluiten van de uitklappers doet <details> zelf, dus dat staat
   hier niet. Wat hier wél staat is het sluiten ná een keuze, en het sluiten als
   je ergens anders klikt.
   ============================================================================ */
(function () {
  'use strict';

  function hoofdveld(optie) {
    // `optie` is bijvoorbeeld "option1". Het formulier hierboven heeft een
    // <select> met precies dat id; die is de bron van waarheid.
    return document.querySelector('.product__details #' + optie)
      || document.querySelector('#' + optie);
  }

  function kies(knop) {
    var optie = knop.getAttribute('data-cl-optie');
    var waarde = knop.getAttribute('data-cl-waarde');
    var veld = hoofdveld(optie);
    if (!veld) return;

    veld.value = waarde;
    veld.dispatchEvent(new Event('change', { bubbles: true }));

    // De samenvatting in de uitklapper meteen bijwerken, zodat je ziet wat je
    // koos ook als het thema er een tel over doet.
    var kader = knop.closest('[data-cl-kies]');
    if (kader) {
      var tekst = kader.querySelector('[data-cl-kieswaarde]');
      if (tekst) tekst.textContent = waarde;

      var punt = knop.querySelector('.cl-pdp__stickypunt');
      var kop = kader.querySelector('summary .cl-pdp__stickypunt');
      if (punt && kop) kop.style.background = punt.style.background;

      var alle = kader.querySelectorAll('[data-cl-optie]');
      for (var i = 0; i < alle.length; i++) alle[i].removeAttribute('aria-current');
      knop.setAttribute('aria-current', 'true');

      kader.open = false;
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var knop = e.target.closest('[data-cl-optie]');
    if (knop) { kies(knop); return; }

    // Ergens anders geklikt: open uitklappers dicht.
    if (!e.target.closest('[data-cl-kies]')) {
      var open = document.querySelectorAll('[data-cl-kies][open]');
      for (var i = 0; i < open.length; i++) open[i].open = false;
    }
  });

  // Escape sluit ook.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelectorAll('[data-cl-kies][open]');
    for (var i = 0; i < open.length; i++) open[i].open = false;
  });
})();

/* ── De balk pas tonen als de echte koopknop voorbij is ──────────────────────
   Stiletto zet de balk vanaf de eerste pixel in beeld. Gemeten op 390 px staat
   hij er bij scrollpositie 0, terwijl de echte knop pas op 1578 px begint — je
   kijkt dus anderhalf scherm lang naar een tweede koopknop terwijl je nog aan
   het oriënteren bent.

   Een IntersectionObserver op de echte knop en niet een scrollteller: de knop
   staat bij elk product op een andere hoogte (langere titel, meer kleuren, wel
   of geen pakketkiezer), dus een vast aantal pixels klopt nergens. */
(function () {
  'use strict';

  var balk = document.querySelector('.sticky-atc-bar');
  if (!balk || !balk.querySelector('.cl-pdp__stickykeuze')) return;

  // De échte knop, niet die in de balk zelf.
  var knop = document.querySelector('.product__details .cl-pdp__knop')
    || document.querySelector('form[action*="/cart/add"] .cl-pdp__knop');
  if (!knop) {
    // Geen knop gevonden: laat de balk gewoon staan zoals hij was.
    balk.classList.add('is-voorbij');
    return;
  }

  // Uitrekenen bij het scrollen en niet met een IntersectionObserver.
  //
  // Die observer was de eerste opzet en werkt bij normaal scrollen prima, maar
  // hij vuurt alleen als de doorsnijding vérandert. Spring je in één keer terug
  // naar boven — een ankerlink, de terug-naar-boven-knop, een herstelde
  // scrollpositie — dan gaat de knop van "boven het scherm" naar "onder het
  // scherm" zonder ooit in beeld te zijn geweest. Er verandert dan niets aan
  // isIntersecting en de balk bleef staan. Gemeten: na scrollTo(0) hield hij
  // `is-voorbij` vast terwijl de knop weer 1578 px lager stond.
  //
  // Eén rect per frame tijdens het scrollen is goedkoop genoeg, en altijd goed.
  var wacht = false;
  function kijk() {
    wacht = false;
    // Voorbij = de knop is omhoog uit beeld verdwenen. Staat hij nog onder het
    // scherm, dan heb je hem nog niet gehad en hoort de balk er niet te zijn.
    balk.classList.toggle('is-voorbij', knop.getBoundingClientRect().bottom < 0);
  }
  function plan() {
    if (wacht) return;
    wacht = true;
    requestAnimationFrame(kijk);
  }

  window.addEventListener('scroll', plan, { passive: true });
  window.addEventListener('resize', plan, { passive: true });
  kijk();
})();
